export const SET_SELECTED_CUSTOMER = 'SET_SELECTED_CUSTOMER'
export const SET_CUSTOMER = 'SET_CUSTOMER'



// WEBPACK FOOTER //
// ./src/store/buyer/types.js